import React, { Fragment, useEffect } from 'react';
import { usePlace } from '../../../hooks/usePlace';
import { debounce, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import '../Dropdown.scss';
import Dropdown from '../../Dropdown';

export function SearchCity(props) {
  const PLACE = usePlace();

  useEffect(() => {
    if (props.idProvince) {
      getData('', props.idProvince);
    }
  }, [props.idProvince]);

  useEffect(() => {
    if (!isEmpty(PLACE.state.params.kota)) {
      props.isCity && props.isCity(PLACE.state.params.kota);
    }
  }, [PLACE.state.params.kota]);

  const getData = (value, idProvince) => {
    const params = {
      meta: {
        filter: { keyword: value, id_province: idProvince },
        page: 1,
        pageSize: 100,
      },
    };
    PLACE.get_city({ params });
  };

  const getDataDebounce = debounce(getData, 800);

  return (
    <Fragment>
      <Dropdown
        disabled={isEmpty(PLACE.state.params.provinsi)}
        handler={{
          select: (ctx) => {
            PLACE.setParams({ type: 'kota', ...ctx });
            PLACE.removeParams({ kecamatan: null });
            PLACE.removeParams({ desa: null });
            props.isCity && props.isCity(ctx);
            props?.setDistrict?.(null);
            props?.setVillage?.(null);
          },
          clear: () => {
            PLACE.removeParams({ kota: null });
            PLACE.removeParams({ kecamatan: null });
            PLACE.removeParams({ desa: null });
            props.isCity && props.isCity(null);
            props.setDistrict && props.setDistrict(null);
            props.setVillage && props.setVillage(null);
          },
          search: (value) => {
            getDataDebounce(value, props.idProvince);
          },
        }}
        isLoading={PLACE.state.city?.status_GET === 'LOADING'}
        options={PLACE.state.city?.list}
        placeholder='City'
        selected={{
          id: PLACE.state.params.kota?.id_kota,
          name: PLACE.state.params.kota?.nama_kota,
          code: PLACE.state.params.kota?.kode_kota,
        }}
        type='kota'
        validation={props.validation}
      />
    </Fragment>
  );
}

SearchCity.propTypes = {
  data: PropTypes.object,
  idProvince: PropTypes.number,
  isCity: PropTypes.func,
  setDistrict: PropTypes.func,
  setVillage: PropTypes.func,
  validation: PropTypes.bool
};
